/* DOPLŇKOVÉ IKONY — to, co lucide-react 0.507 nemá.
 * ============================================================================
 *
 * Appka má JEDNU sadu ikon: lucide (mřížka 24 × 24, tah 2 px, kulatá
 * zakončení, barva currentColor). Pro pár pojmů z financí v ní ale kresba
 * chybí: senior, invalidní vozík, berle, kočárek, symbol Kč, dům se štítem
 * a nabourané auto. Místo druhé knihovny (další vizuální jazyk, 66 MB balík)
 * je tu sedm kreseb ze sad, které kreslí STEJNĚ jako lucide.
 *
 * Každá je obalená `createLucideIcon` z lucide-react, takže se chová přesně
 * jako lucide ikona: stejné props (`size`, `strokeWidth`, `color`, `className`),
 * stejné výchozí `aria-hidden="true"`, když nemá popisek.
 *
 * Nová ikona sem smí jen tehdy, když ji lucide opravdu nemá (ověř v
 * node_modules/lucide-react/dist/lucide-react.d.ts) — a vždy i se zdrojem
 * a licencí. Hlídá to __tests__/ikonySlovniky.test.js (každá doplňková
 * ikona má záznam v DOPLNKY_ZDROJE).
 *
 * ─── LICENCE ────────────────────────────────────────────────────────────────
 *
 * Tabler Icons — https://github.com/tabler/tabler-icons (icons/outline/*.svg)
 *   MIT License
 *   Copyright (c) 2020-2026 Paweł Kuna
 *   Permission is hereby granted, free of charge, to any person obtaining a
 *   copy of this software and associated documentation files (the "Software"),
 *   to deal in the Software without restriction, including without limitation
 *   the rights to use, copy, modify, merge, publish, distribute, sublicense,
 *   and/or sell copies of the Software, and to permit persons to whom the
 *   Software is furnished to do so, subject to the following conditions:
 *   The above copyright notice and this permission notice shall be included in
 *   all copies or substantial portions of the Software.
 *   THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 *   IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 *   FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 *   AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 *   LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
 *   FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER
 *   DEALINGS IN THE SOFTWARE.
 *
 * Lucide Lab — https://github.com/lucide-icons/lucide-lab (icons/*.svg)
 *   ISC License
 *   Copyright (c) for portions of Lucide are held by Cole Bemis 2013-2022 as
 *   part of Feather (MIT). All other copyright (c) for Lucide are held by
 *   Lucide Contributors 2022.
 *   Permission to use, copy, modify, and/or distribute this software for any
 *   purpose with or without fee is hereby granted, provided that the above
 *   copyright notice and this permission notice appear in all copies.
 *   THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
 *   WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
 *   MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY
 *   SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
 *   WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN
 *   ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF OR
 *   IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
 *
 * Kresby jsou převzaté beze změny (jen `path`/`circle` přepsané do tvaru,
 * který čte lucide). Staženo 30. 9. 2026 z větve main obou repozitářů.
 */
import { createLucideIcon } from "lucide-react";

/** Senior (starobní důchod, stáří). Tabler `old` — MIT. */
export const Senior = createLucideIcon("bp-senior", [
  ["path", { d: "M11 21l-1 -4l-2 -3v-6", key: "s1" }],
  ["path", { d: "M5 14l-1 -3l4 -3l3 2l3 .5", key: "s2" }],
  ["path", { d: "M7 4a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", key: "s3" }],
  ["path", { d: "M7 17l-2 4", key: "s4" }],
  ["path", { d: "M16 21v-8.5a1.5 1.5 0 0 1 3 0v.5", key: "s5" }],
]);

/** Invalidní vozík (invalidita). Tabler `wheelchair` — MIT.
 *  Lucide má jen piktogram přístupnosti (`Accessibility`), který čte jako
 *  „bezbariérovost", ne jako riziko invalidity. */
export const InvalidniVozik = createLucideIcon("bp-invalidni-vozik", [
  ["path", { d: "M3 16a5 5 0 1 0 10 0a5 5 0 1 0 -10 0", key: "v1" }],
  ["path", { d: "M17 19a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", key: "v2" }],
  ["path", { d: "M19 17a3 3 0 0 0 -3 -3h-3.4", key: "v3" }],
  ["path", { d: "M3 3h1a2 2 0 0 1 2 2v6", key: "v4" }],
  ["path", { d: "M6 8h11", key: "v5" }],
  ["path", { d: "M15 8v6", key: "v6" }],
]);

/** Berle (trvalé následky úrazu). Tabler `crutches` — MIT. */
export const Berle = createLucideIcon("bp-berle", [
  ["path", { d: "M8 5a2 2 0 0 1 2 -2h4a2 2 0 0 1 2 2a2 2 0 0 1 -2 2h-4a2 2 0 0 1 -2 -2", key: "b1" }],
  ["path", { d: "M11 21h2", key: "b2" }],
  ["path", { d: "M12 21v-4.092a3 3 0 0 1 .504 -1.664l.992 -1.488a3 3 0 0 0 .504 -1.664v-5.092", key: "b3" }],
  ["path", { d: "M12 21v-4.092a3 3 0 0 0 -.504 -1.664l-.992 -1.488a3 3 0 0 1 -.504 -1.664v-5.092", key: "b4" }],
  ["path", { d: "M10 11h4", key: "b5" }],
]);

/** Kočárek (rodičovská, narození dítěte). Lucide Lab `pram` — ISC. */
export const Kocarek = createLucideIcon("bp-kocarek", [
  ["path", { d: "M18.7 4.4 14.5 10", key: "k1" }],
  ["path", { d: "M13 10V2a8.1 8.1 0 0 1 8 8v1c0 1.7-1.3 3-3 3H6c-1.7 0-3-1.3-3-3v-1h18", key: "k2" }],
  ["path", { d: "m8.2 18.4 3.3-4.4", key: "k3" }],
  ["circle", { cx: "7", cy: "20", r: "2", key: "k4" }],
  ["path", { d: "M15.8 18.4 5.6 4.8A1.94 1.94 0 0 0 2 6", key: "k5" }],
  ["circle", { cx: "17", cy: "20", r: "2", key: "k6" }],
]);

/** Česká koruna (měna CZK). Tabler `currency-krone-czech` — MIT.
 *  Používá se JEN přes `ikonaMeny()` podle ZEMĚ TENANTA — nikdy natvrdo. */
export const Koruna = createLucideIcon("bp-koruna", [
  ["path", { d: "M5 6v12", key: "c1" }],
  ["path", { d: "M5 12c3.5 0 6 -3 6 -6", key: "c2" }],
  ["path", { d: "M5 12c3.5 0 6 3 6 6", key: "c3" }],
  ["path", { d: "M19 6l-2 2l-2 -2", key: "c4" }],
  ["path", { d: "M19 12h-2a3 3 0 0 0 0 6h2", key: "c5" }],
]);

/** Dům se štítem (pojištění majetku). Tabler `home-shield` — MIT.
 *  Odliší pojištění domu od cíle „Bydlení" (holý `House`). */
export const DumSeStitem = createLucideIcon("bp-dum-se-stitem", [
  ["path", { d: "M5 12h-2l9 -9l7.636 7.636", key: "d1" }],
  ["path", { d: "M5 12v7a2 2 0 0 0 2 2h5", key: "d2" }],
  ["path", { d: "M9 21v-6a2 2 0 0 1 2 -2h1.5", key: "d3" }],
  ["path", { d: "M22 16c0 4 -2.5 6 -3.5 6s-3.5 -2 -3.5 -6c1 0 2.5 -.5 3.5 -1.5c1 1 2.5 1.5 3.5 1.5", key: "d4" }],
]);

/** Nabourané auto (pojištění auta). Tabler `car-crash` — MIT.
 *  Odliší pojištění auta od cíle „Auto" (holý `Car`). */
export const AutoNehoda = createLucideIcon("bp-auto-nehoda", [
  ["path", { d: "M8 17a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", key: "a1" }],
  ["path", { d: "M7 6l4 5h1a2 2 0 0 1 2 2v4h-2m-4 0h-5m0 -6h8m-6 0v-5m2 0h-4", key: "a2" }],
  ["path", { d: "M14 8v-2", key: "a3" }],
  ["path", { d: "M19 12h2", key: "a4" }],
  ["path", { d: "M17.5 15.5l1.5 1.5", key: "a5" }],
  ["path", { d: "M17.5 8.5l1.5 -1.5", key: "a6" }],
]);

/** Odkud která kresba je — pro test a pro Vzorkovnu. */
export const DOPLNKY_ZDROJE = Object.freeze({
  Senior: { sada: "Tabler Icons", nazev: "old", licence: "MIT" },
  InvalidniVozik: { sada: "Tabler Icons", nazev: "wheelchair", licence: "MIT" },
  Berle: { sada: "Tabler Icons", nazev: "crutches", licence: "MIT" },
  Kocarek: { sada: "Lucide Lab", nazev: "pram", licence: "ISC" },
  Koruna: { sada: "Tabler Icons", nazev: "currency-krone-czech", licence: "MIT" },
  DumSeStitem: { sada: "Tabler Icons", nazev: "home-shield", licence: "MIT" },
  AutoNehoda: { sada: "Tabler Icons", nazev: "car-crash", licence: "MIT" },
});

export const DOPLNKY = Object.freeze({ Senior, InvalidniVozik, Berle, Kocarek, Koruna, DumSeStitem, AutoNehoda });
